import { apiAxiosInstance, post } from "./handler";
export const auth = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/login",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
